import axios from 'axios';
import { backend_url, env } from '@/shared/constants/env-variables';

export enum AXIOS_STRING_ERROR_CODES {
	CANCELED = 'ERR_CANCELED',
	NETWORK_ERROR = 'ERR_NETWORK',
	TIMEOUT = 'ECONNABORTED',
}

const axiosConfigWithCredentials = {
	baseURL: `${backend_url}`,
	withCredentials: true,
} as const;

export const api = axios.create(axiosConfigWithCredentials);

/**
 * Instância do axios sem interceptors.
 * Use apenas para requisições de refresh token e logout
 * para evitar loops infinitos de interceptors.
 */
export const authless = axios.create(axiosConfigWithCredentials);

export const viacep = axios.create({
	baseURL: env.NEXT_PUBLIC_VIACEP_URL,
	timeout: 3000,
});
